/*
 * Copyright (c) 2026 SimplyBook.me Ltd. All rights reserved.
 * Licensed under the Apache License, Version 2.0.
 */

import React from "react";
import Label from "../Label";
import { useController } from "react-hook-form";
import { StyledFormField } from "./StyledFormField";
import { useTranslate } from "../../../hooks/useTranslate";

const EmailField = ({
  control,
  name,
  label,
  required = false,
  defaultValue,
  validationRules = {},
  placeholder,
  hideRequiredIndicator = false,
  ...props
}) => {
  const { _t } = useTranslate();
  const { field, fieldState } = useController({
    name,
    control,
    rules: {
      required: required ? "error_value_is_empty" : undefined,
      pattern: {
        value: /\S+@\S+\.\S+/,
        message: "error_value_is_not_email",
      },
      ...validationRules,
    },
    defaultValue: defaultValue || "",
  });

  return (
    <>
      {label ? (
        <Label name={name} required={required && !hideRequiredIndicator}>
          {label}
        </Label>
      ) : undefined}
      <StyledFormField.Input
        {...field}
        id={name}
        type="email"
        $error={fieldState.error}
        aria-invalid={!!fieldState.error}
        aria-required={required || undefined}
        aria-describedby={fieldState.error ? `${name}-error` : undefined}
        placeholder={_t(placeholder)}
        {...props}
      />
    </>
  );
};

export default EmailField;
